import Nullstack from 'nullstack';
export default function IconSwitchHorizontal({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-switch-horizontal",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("polyline", {
    points: "16 3 20 7 16 11"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "7",
    x2: "20",
    y2: "7"
  }), "   ", Nullstack.element("polyline", {
    points: "8 13 4 17 8 21"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "17",
    x2: "13",
    y2: "17"
  }), " ");
}